<div class="source-summary">
  @if (providers.length) {
    <span class="source-summary-label"
      >{{ 'source.label.sources' | translate }}:</span
    >
    @for (provider of providers; track provider) {
      <span
        class="source-badge source-badge-static"
        [title]="'source.name.' + provider | translate"
        >{{ abbreviations[provider] }}</span
      >
    }
  }
  <button
    type="button"
    class="source-legend-button"
    (click)="legendPanel.toggle($event)"
  >
    {{ 'source.label.legend' | translate }}
  </button>
  <label class="source-toggle">
    <input
      type="checkbox"
      [checked]="display.visible$ | async"
      (change)="toggle($event)"
    />
    {{ 'source.label.show' | translate }}
  </label>
</div>
<app-overlay-panel #legendPanel styleClass="source-popover">
  <div class="source-popover-content">
    <dl class="source-legend">
      @for (source of legend; track source) {
        <dt>
          <span class="source-badge source-badge-static">{{
            abbreviations[source]
          }}</span>
        </dt>
        <dd>{{ 'source.name.' + source | translate }}</dd>
      }
    </dl>
    <p>{{ 'source.label.priority' | translate }}</p>
    <p>{{ 'source.label.tracxnHint' | translate }}</p>
  </div>
</app-overlay-panel>
